import type { ReactNode } from 'react'

interface DisclosureSectionProps {
  summary: string
  meta?: string
  children: ReactNode
  disclosureId?: string
  defaultOpen?: boolean
}

export function DisclosureSection({
  summary,
  meta,
  children,
  disclosureId,
  defaultOpen = false,
}: DisclosureSectionProps) {
  return (
    <details
      data-disclosure={disclosureId}
      open={defaultOpen ? true : undefined}
      className="km-disclosure"
    >
      <summary>
        <span>{summary}</span>
        {meta ? <span className="km-disclosure-meta">{meta}</span> : null}
      </summary>
      <div className="km-disclosure-body">{children}</div>
    </details>
  )
}
